import styled from 'styled-components';

import { basicBodyTextStyle, Text } from '@dreryk/react-components';

export const StyledVisitLocationText = styled.div`
   overflow: hidden;
   display: flex;
   align-items: center;
   max-width: 30%;
`;
StyledVisitLocationText.displayName = 'StyledVisitLocationText';

export const StyledText = styled(Text)`
   ${basicBodyTextStyle};
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
`;
StyledText.displayName = 'StyledText';
